import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { ChannelkartNetworkGet } from './services/networkService'
import { getLob } from './services/authenticationService'

async function loadTranslationsFromServer(url: string){
    try{
        const lob = getLob()
        const response = await ChannelkartNetworkGet(url,undefined,localStorage.getItem("lob")? undefined : { Lob: lob} );
        if(response.status === 200 && response?.data?.features){
            const translationMapping: {[key: string] : {[key: string]: string} } = {};
            response?.data?.features?.forEach((translationObj: any) => {
                const component = translationObj.component;
                const keyInSnakeCase = translationObj.translationKey.replace(/ /g,"_");
                const value = translationObj.translationValue;
                const newTranslationCompObj = {...translationMapping[component],[keyInSnakeCase]: value}
                translationMapping[component] = newTranslationCompObj;
            })
            return translationMapping;
        }else{
            throw new Error("Error fetching translations");
        }
    }catch(err){
        return {};
    }
    
}
const backendOptions = {
    loadPath: '/v1/translations?size=5000&filter=translationLanguage:{{lng}}',
    request: async (options:any, url:any, payload:any, callback:any) => {
        try {
        const translationMapping = await loadTranslationsFromServer(url);
        callback(null,{
            data: translationMapping,
            status: 200
        })
        } catch (e) {
          console.error(e);
          callback(null, {
            status: 500,
          });
        }
      },
}

i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // supportedLngs: ['en', 'ar', 'fr'],
    fallbackLng: 'en',
    debug: false,
    // Options for language detector
    detection: {
      order: ['cookie', 'htmlTag'],
      caches: ['cookie'],
    },
    // react: { useSuspense: false },
    backend: backendOptions,
  })

  export default i18next;